import moment from "moment";
import debounce from 'lodash/debounce';
import { dateFiterChoice, kowaFiterChoice, numericFiterChoice, stringFilterChoice } from "../const/customFilterconst/filterOptions";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { RESOURCE } from "../const/resource";
import DistributorService from "../services/distributorservice";

const setDefaultUserSessionForShoppingCart = (azureAadId : any) => {
    if (azureAadId) {
        let data = { shoppingcart: JSON.stringify({ isCartToolMenuExpanded: false }) };
        DistributorService.setSessionData(azureAadId, data)
            .then(() => { })
            .catch(() => { });
    }
}

const MenuClickEvent = (url: string, target: string) => {
    if (url != null && url.length > 0) {
        if (target == null || target == "" || target?.toLowerCase() == "_blank" || target?.toLowerCase() == "blank") window.open(url, "_blank");
        else window.location.replace(url);
    }
};

const ClearLocalStorage = () => {
    try {
        localStorage.clear();
        sessionStorage.clear();
    } catch (e) { }
};

const NumberFormat = (number: any, decimalPoint: number = 2) => {
    return new Intl.NumberFormat("en-US", { style: "decimal", minimumFractionDigits: decimalPoint, maximumFractionDigits: decimalPoint }).format(
        number
    );
};

const DateFormat = (date: any) => {
    return new Date(Date.parse(date || "0001/01/01")).toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" });
};

const getDateWithLocalFormat = (date: any, culture: any) => {
  let formattedDateTime = "";
  if (date != undefined && date != "" && date != null) {
    let localDatetime = moment.utc(date).toDate();
    const time = DateFormatbasedONRegion(localDatetime, culture);
    const timeZone = moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).zoneAbbr();
    let onlytimeConversion = moment(localDatetime).format('hh:mm A');
    formattedDateTime = `${time} ${onlytimeConversion} ${timeZone}`;
  }
  return formattedDateTime;
}
const DateFormatbasedONRegion = (date: moment.MomentInput, currentUser: any, region: string = "", isTime: boolean = false) => {
    let country = currentUser?.userpreference?.culture
    if (typeof country !== 'string') {
        country = 'en-US';
    }
    const isEnglishLocale = country.includes('en');
    let formatString = isEnglishLocale ? 'MM/DD/YYYY' : 'DD/MM/YYYY';

    const parsedDate = date ? moment.utc(date) : moment('0001/01/01', 'DD/MM/YYYY');
    const defaultFormatConst = currentUser?.defaultDateFormat ? currentUser?.defaultDateFormat?.toLowerCase() : "";
    if (defaultFormatConst == "dd-mmm-yyyy") {
        formatString = 'DD-MMM-YYYY';
        if (defaultFormatConst) {
            formatString = defaultFormatConst;
        }
    }
    
    let newFormat = formatString.toUpperCase();
    if(isTime){
        newFormat = newFormat + ' hh:mm:ss A';
    }
    const formattedDate = parsedDate.format(newFormat);
    return formattedDate;

};


const YearMonthFormat = (dateString: any) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2); // Months are zero-based, so we add 1

    return year + "-" + month;
};

const AddFiltertoEndpoint = (filterOrSortCriteria: any, endPoint: string, isFilter: any) => {
    if (filterOrSortCriteria) {
        if (Array.isArray(filterOrSortCriteria)) {
            endPoint += `&$filter=`;
            filterOrSortCriteria.forEach((filter: any, index: number) => {
                switch (filter?.filters[0]?.operator) {
                    case "contains":
                        endPoint += `contains(${filter.filters[0].field},'${filter.filters[0].value}')`;
                        break;
                    case "doesnotcontain":
                        endPoint += `contains(${filter.filters[0].field},'${filter.filters[0].value}') ne true`;
                        break;
                    case "isequalto":
                        endPoint += `${filter.filters[0].field} eq '${filter.filters[0].value}'`;
                        break;
                    case "isnotequalto":
                        endPoint += `${filter.filters[0].field} ne '${filter.filters[0].value}'`;
                        break;
                    case "startswith":
                        endPoint += `startswith(${filter.filters[0].field},'${filter.filters[0].value}')`;
                        break;
                    case "endswith":
                        endPoint += `endswith(${filter.filters[0].field},'${filter.filters[0].value})'`;
                        break;
                    case "isnull":
                        endPoint += `${filter.filters[0].field} eq null`;
                        break;
                    case "isnotnull":
                        endPoint += `${filter.filters[0].field} ne null)`;
                        break;
                    case "isempty":
                        endPoint += `${filter.filters[0].field} eq '')`;
                        break;
                    case "isnotempty":
                        endPoint += `${filter.filters[0].field} ne ''`;
                        break;
                    case "isgreaterthanorequalto":
                        endPoint += `${filter.filters[0].field} ge ${filter.filters[0].value}`;
                        break;
                    case "isgreaterthan":
                        endPoint += `${filter.filters[0].field} gt ${filter.filters[0].value})`;
                        break;
                    case "islessthan":
                        endPoint += `${filter.filters[0].field} lt ${filter.filters[0].value})`;
                        break;
                    case "islessthanorequalto":
                        endPoint += `${filter.filters[0].field} le ${filter.filters[0].value}`;
                        break;
                    default:
                        break;
                }
                if (filterOrSortCriteria.length - 1 != index) endPoint += " and ";
            });
        } else {
            endPoint += isFilter ? "&$filter=" + filterOrSortCriteria : "?$orderby=" + filterOrSortCriteria;
        }
    }
    return endPoint;
};

function extractUniqueKeys(obj: any) {
    const keysSet = new Set();

    function extractKeys(obj: any) {
        for (const key in obj) {
            if (typeof obj[key] === "object" && obj[key] !== null) {
                extractKeys(obj[key]);
            } else {
                keysSet.add(key);
            }
        }
    }
    extractKeys(obj);
    return Array.from(keysSet);
}

function addSpaceToCamelCase(sentence: string) {
    return sentence.replace(/(?<=[a-z])(?<!\b[A-Z])[A-Z]/g, " $&").trim();
}

function createSortOptions(compKeys: any[]) {
    return compKeys.map((key: any, index: number) => ({
        key: compKeys[index],
        text: addSpaceToCamelCase(key).toLocaleUpperCase(),
    }));
}


function formatDateWithMoment(dateString: moment.MomentInput, format: string) {
    return moment(dateString, moment.ISO_8601).isValid() ? moment(dateString).format(format) : dateString;
}

// Function to format dates in an array of objects with dynamic key names
function formatDatesInArray(array: any[], format: any) {
    return array.map((obj: { [x: string]: any; hasOwnProperty: (arg0: string) => any }) => {
        const newObj: { [key: string]: string | any } = {};

        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];
                newObj[key] = typeof value === "string" ? formatDateWithMoment(value, format) : value;
            }
        }

        return newObj;
    });
}

function cptArrayConversion(data: any) {
    const uniqueSegments = new Set();
    return Object.keys(data)
        .filter(key => key !== "count" && key !== "result")
        .flatMap(key => data[key])
        .filter((item: any) => {
            if (uniqueSegments.has(item.segmentId)) {
                return false;
            } else {
                uniqueSegments.add(item.segmentId);
                return true;
            }
        });
}


function transformCptExp(expression: string) {
    const regex = /contains\(([^,]+),\s*'([^']+)'\)/;
    return expression.replace(regex, (_, field, searchString) => {
        return `contains(tolower(${field}), tolower('${searchString}'))`;
    });
}

function transformCPTInput(inputString: string) {
    const expressions = inputString.split(/\b(And|Or)\b/);
    if (expressions) {
        const transformedExpressions = expressions.map((exp, index) => {
            if (index % 2 === 0) {
                return transformCptExp(exp);
            } else {
                return exp;
            }
        });

        return transformedExpressions.join("");
    } else {
        return inputString;
    }
}


const getVisibilityClass = (condition: any) => {
    return condition ? 'visible  ' : 'd-none  ';
};

const isVisibleBasedOnRole = (isPLM: any, isVHMS: any, isInternationDbUser: any, usertype: string,) => {
    if (usertype === 'employee') {
        return true;
    } else if (usertype === 'distributor' && isInternationDbUser) {
        return false;
    } else if (usertype === 'distributor') {
        return true;
    }
    else if ((usertype === 'customer' && (isPLM || isVHMS))) {
        return false;
    } else {
        return true;
    }
};

const shareTo = (item: any, userPreference: any, unitMeasurement: any, region: string = "", user: any = {}) => {
  const lastMessageDate = item.lmdt ? DateFormatbasedONRegion(item.lmdt, user, region) : '';
  const latestSMRDate = item.lsmrdt ? DateFormatbasedONRegion(item.lsmrdt, user, region) : '';
  const model: string = item.mo ? item.mo : '';
  const serial: string = item.sn ? item.sn : '';
  const latestSMR: string = item.smr ? item.smr : '';
  const idleRate: string = item.ir ? item.ir : 0;
  const locationName: string = item.territoryLocation ? item.territoryLocation : '-';
  const fleetCriticalStatusValue: string = item.cs ? item.cs : '';
  const payloadTons = NumberFormat(item?.pt) || '-';
  const productiveTonnes = NumberFormat(item?.cp) || '-';
  const holeCount = NumberFormat(item?.hc) || '-';

  let body = item?.mtid > 5 ? generateBodyForMtidGreaterThan5({item, latestSMRDate, latestSMR, payloadTons, productiveTonnes, holeCount, locationName, fleetCriticalStatusValue, model, serial}) 
                            : generateBodyForMtidLessThanOrEqualTo5({item, lastMessageDate, latestSMRDate, latestSMR, idleRate, unitMeasurement, locationName, fleetCriticalStatusValue, model, serial});

  window.open(`mailto:?subject=${item.machineName} (${item.mo})&body=${encodeURIComponent(body)}`)
}

const generateBodyForMtidGreaterThan5 = (details: any) => {
    let body = 'Status : ' + details?.fleetCriticalStatusValue + '\n' + 'Model : ' + details?.model + '\n' + 'Serial : ' + details?.serial;
    if (details?.item?.pc.toLowerCase() !== "dipper") {
      body += '\n' + 'SMR date : ' + details?.latestSMRDate + '\n' + 'SMR (H) : ' + details?.latestSMR;
      if (details?.item?.pc.toLowerCase() === "electric shovel") {
        body += '\n' + 'Payload (Tonnes) : ' + details?.payloadTons;
      } else if (details?.item?.pc.toLowerCase() === 'loader') {
        body += '\n' + 'Productive tons : ' + details?.productiveTonnes;
      } else if (details?.item?.pc.toLowerCase() === "drill") {
        body += '\n' + 'Hole count : ' + details?.holeCount;
      }
    }
    body += '\n' + 'Physical location : ' + details.locationName + '\n\n';
    return body;
}
const generateBodyForMtidLessThanOrEqualTo5 = (details: any) => {
  return 'Status : ' + details?.fleetCriticalStatusValue + '\n'
    + 'Model : ' + details?.model + '\n' + 'Serial : ' + details?.serial + '\n' + 'Last reported : '
    + details?.lastMessageDate + '\n' + 'SMR (H) : ' + details?.latestSMR + '\n'
    + 'SMR date : ' + details?.latestSMRDate + '\n' + 'Engine hours (H) : ' + NumberFormat(details?.item?.wh) + '\n' + 'Idle time : ' + NumberFormat(details?.idleRate) + ' %' + '\n' + 'Fuel burned : ' + NumberFormat(details?.item?.fu) + (details?.unitMeasurement == 'gal' ? ' gal' : ' Liters') + '\n'
    + 'Physical location : ' + details?.locationName + '\n\n';
}

export const getFiltersByKeyAsString = (arr: any[], keyToFilter: any, val?: any) => {
    const filteredItems = arr && arr?.filter((obj: { key: any }) => obj?.key === keyToFilter);
    const filters = filteredItems.map((obj: any[]) => obj.filter);
    const filtersString = filters ? filters.join(", ") : filteredItems[0].key;
    return filtersString;
}

export function dateIsValid(dateStr: any) {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (dateStr.match(regex) === null) {
        return false;
    }
    const date = new Date(dateStr);
    const timestamp = date.getTime();
    if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
        return false;
    }
    return date.toISOString().startsWith(dateStr);
}
const generateCustomFilter = (components: any) => {
    const getRestype = (item: any) => {
        const itemType = getFiltersByKeyAsString(stringFilterChoice, item.selected, item.field);
        const isValidDate = dateIsValid(item.value);
        const numericVal = ["smr", "wh", "ir", "fu", "fc"]
        let val;
        if (isValidDate) {
            val = item.value;
        } else {
            if (itemType || (!numericVal.includes(item.field?.toLowerCase()))) {
                val = `'${item.value}'`;
            } else {
                val = item.value;
            }
        }
        const isStringKeys = ["Contains", "startswith", "endswith", "not contains"];
        if (isStringKeys.includes(item.selected)) {
            return `${item.selected}(${item.field},  ${val})`;
        } else if (item.field === "kwa" || item.field === "Ioemac") {
            return `(${item.field} eq ${val?.replace(/'/g, '')})`;
        } else if (item.selected == "eq null") {
            return `(${item.field} eq 'null')`;
        } else {
            return `(${item.field} ${item.selected} ${val})`;
        }
    };
    return (
        components &&
        components
            ?.filter((item: any) => item.field !== "")
            .map((item: any) => {
                const operator = item.operator == "" ? " and " : item.operator;
                const restype = getRestype(item);
                return ` ${operator} ${restype}`;
            })
    );
};

export function handleCustomFilterCriteria(
    customFilterMyfleet: any,
    setFilterCriteria: any,
    filterOrSortCriteria: any
) {
    if (!shouldApplyCustomFilter(customFilterMyfleet)) {
        return;
    }
    const { filterContent, filterType } = generateFilterContent(customFilterMyfleet);
    const debouncedSetFilterCriteria = debounce(setFilterCriteria, 300);
    const debouncedFilterOrSortCriteria = debounce(filterOrSortCriteria, 300);

    debouncedSetFilterCriteria(filterContent);
    debouncedFilterOrSortCriteria(filterType);
}

function shouldApplyCustomFilter(customFilterMyfleet: any): boolean {
    const hasValidFilters = customFilterMyfleet?.filters?.every((filter: string | string[]) => filter && !filter.includes("undefined"));
    const hasAppendedComponents = customFilterMyfleet?.appendedComponents?.length > 0;
    return hasValidFilters || hasAppendedComponents;
}

function generateFilterContent(customFilterMyfleet: any): {
    filterContent: string;
    filterType: string;
} {
    const filters = customFilterMyfleet?.filters ?? [];
    let ForNullcheck = filters[0] && (filters[0].includes("eq null") &&
        filters[0]
            .replace(/(eq\s+null\s*\()|(\))/g, "")
            .replace(/["']/g, "")
            .replace(/,/g, "")
            .trimEnd())
    const filter = ForNullcheck
        ? `(${ForNullcheck} eq '${null}')`
        : `${(filters[0] || "") + " " + (filters[1] || "") + " " + (filters[2] || "")}`.trimEnd();

    const customFilter = customFilterMyfleet?.appendedComponents ? generateCustomFilter(customFilterMyfleet?.appendedComponents) : '';
    let filterType = "";
    if (customFilterMyfleet?.type == "FilterBy") {
        filterType = "filter";
    } else if (customFilterMyfleet?.type == "SortBy") {
        filterType = "sort";
    }
    const custFilter = customFilter.length > 0 ? customFilter.join(" ").trimEnd() : customFilter;
    const filterContent = `${filter} ${custFilter}`;
    return { filterContent, filterType };
}

export const replaceSecondFilter = (inputString: any) => {
    let count = 0;
    return inputString.replace(/&\$filter=/g, (match: any) => {
        count++;
        return count === 2 ? "and " : match;
    });
};


export const getFiltersoptions = (arr: any[], keyToFilter: any) => {
    const filteredItems = arr && arr?.filter((obj: { key: any }) => obj.key === keyToFilter);
    const filters = filteredItems.map((obj: any[]) => obj.filter);
    const filtersString = filters.join(", ");
    return filtersString;
}

export const getDataOptions = (value: any, dynamicList: any) => {
  switch (value) {
    case "date":
      return dateFiterChoice;
    case "number":
      return numericFiterChoice;
    case "kwa":
      return kowaFiterChoice;
    case "Ioemac":
      return kowaFiterChoice;
    case "string":
      return stringFilterChoice;
      case "mos":
      return dynamicList;
    default:
      return stringFilterChoice;
  }
}

export const showErrorMessage = (message: any) => {
  toast.error(message, { style: { fontSize: 12 }, position: toast.POSITION.BOTTOM_RIGHT, hideProgressBar: true, icon: true, autoClose: 6000 });
}

export const showSuccessMessage = (message: any) => {
  toast.success(message, { style: { fontSize: 12 }, position: toast.POSITION.BOTTOM_RIGHT, hideProgressBar: true, icon: true, autoClose: 6000 });
}

export const showErrorMessageTop = (message: any) => {
  toast.error(message, { style: { fontSize: 12 }, position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, icon: true, autoClose: 6000 });
}

export const showSuccessMessageTop = (message: any) => {
  toast.success(message, { style: { fontSize: 12 }, position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, icon: true, autoClose: 6000 });
}

export const showWarningMessage = (message: any) => {
    toast.warn(message, { style: { fontSize: 12 }, position: toast.POSITION.BOTTOM_RIGHT, hideProgressBar: true, icon: true, autoClose: 6000});
}

export const showCreditWarningMessage= (message: any) => {
    toast.warn(message, { style: { fontSize: 12 }, position: toast.POSITION.BOTTOM_RIGHT, hideProgressBar: true, icon: true, autoClose: 6000, toastId: "creditwarningtoaster" });
}

export const showRemainderMessageTop = (message: any, className:any) => {
  toast.success(message, { className, style: { fontSize: 12 }, position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, icon: true, autoClose: 6000 });
}

export const getMachineTitle = (model: any, serial: any, unit: any) => {
  let title = model;
  if (serial && serial != "" && serial != "'") {
    title += " (" + serial + ")"
  }
  if (unit && unit != "" && unit != "'") {
    title += " (" + unit + ")"
  }

  return title;
}

const formatAmount = (amount: any) => {
  const inputAmount = (amount && !isNaN(amount)) ? Number(amount) : 0;
  const formattedAmount = inputAmount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });;
  return formattedAmount;
}

const getUnitPrice = (amount: any, t: any, isContacDealer: any = true) => {
    if (isContacDealer) {
        return t(RESOURCE.MyK_Label_SC_Contact_Dealer);
    }
    return `$${formatAmount(amount)}`;
}

const validEmailCheck = (email: any) => {
    const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    if (emailRegex.test(email)) {
        const domain = email.split('@')?.[1];
        const subdomains = domain ? domain.split('.') : '';
        if (subdomains?.length === 2) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

const validPhoneCheck = (phone: any) => {
    const val = phone || '';
    const digitsOnly = val.replace(/\D/g, '');
    if (digitsOnly?.length === 10) {
        return true;
    } else {
        return false;
    }
}

const validPhoneCheckWithPhoneCode = (phone: any, phoneCode: any) => {
    const val = phone || '';
    const digitsOnly = val.replace(/\D/g, '');
    if ((phoneCode == "+1" && digitsOnly?.length === 10) || (phoneCode != "+1" && digitsOnly?.length <= 15)) {
        return true;
    } else {
        return false;
    }
}

const minMaxValidation = (value: any, min: number, max: number) => {
    if (value == null || value < min || value > max) {
        return false;
    }
    return true;
}

const requiredValidation = (value: any) => {
    if (value?.toString()?.trim() == "" || value == null || value?.toString()?.trim() == '') {
        return false;
    }
    return true;
}

const lengthValidation = (value: any, maxLength: number) => {
    if (value?.length > maxLength) {
        return false;
    }
    return true;
}

const shareOrderConfirmation = (response: any, attachmentUrl:any, t:any) => {
    const details = response?.details ?? {};
    const poNumber = details?.poNumber && details?.poNumber != "" ? details?.poNumber : 'N/A'; 
    const orderNo = details?.orderNo && details?.orderNo != "" ? details?.orderNo : 'N/A'; 
    const emailbody = 
        `${t(RESOURCE.Myk_Label_SC_ShareEmail_Line1)},`
        + '\n\n'
        + `${t(RESOURCE.Myk_Label_SC_ShareEmail_Line2)?.replace("{0}", details?.dealer)} `
        + `${t(RESOURCE.Myk_Label_SC_ShareEmail_Line2_Link)} ${attachmentUrl} ${t(RESOURCE.Myk_Label_SC_ShareEmail_Line2_Download)}. \n\n`
        + `${t(RESOURCE.Myk_Label_SC_ShareEmail_MykRef)}: ${details?.myKomatsuReference} \n`
        + `${t(RESOURCE.MyK_Label_SC_Order)} #: ${orderNo} \n`
        + `${t(RESOURCE.Myk_Label_OrderHistory_OrderDate)}: ${details?.orderDate ? moment(details.orderDate).format('MM-DD-YYYY') : 'N/A'} \n`
        + `${t(RESOURCE.Myk_Label_SC_ShareEmail_PurchaseOrder)}: ${poNumber} \n\n`
        + `${t(RESOURCE.Myk_Label_SC_ShareEmail_Line3)} \n\n`
        + `${t(RESOURCE.Myk_Label_SC_ShareEmail_Line4)} \n\n`
        + `${t(RESOURCE.Myk_Label_SC_ShareEmail_Line5)}, \n`
        + 'My Komatsu Team  \n'
    window.open(`mailto:?subject=${response?.title}&body=${encodeURIComponent(emailbody)}`)
}

const getTextWidth = (text: string, font: string, width: any): number => {
    if (text) {
        let canvas: HTMLCanvasElement = (getTextWidth as any).canvas || ((getTextWidth as any).canvas = document.createElement("canvas"));
        let context = canvas.getContext("2d");
        let maxWidth = 0;
        let txtWidth = 0;
        if (context) {
            context.font = font;
            let metrics = context.measureText(text);
            txtWidth = metrics.width;
        }
        const size = txtWidth + 100;
        if (size > maxWidth) {
            maxWidth = size;
            if (maxWidth < 150) {
                maxWidth = width;
            }
        }
        return maxWidth;
       
    } else {
        return width;
    }
}

const customMonthYearFormat = (format: string , value: Date) => {
    let dateFormat;
    const defaultFormat = format || "MM/DD/YYYY";
    if (defaultFormat && value) {
        switch (defaultFormat?.toUpperCase()) {
            case "DD/MM/YYYY":
                dateFormat = "MM/YYYY"
                break;
            case "MM/DD/YYYY":
                dateFormat = "MM/YYYY"
                break;
            case "DD-MMM-YYYY":
                dateFormat = "MMM-YYYY"
                break;
            case "DD/MMM/YYYY":
                dateFormat = "MMM-YYYY"
                break;
            default:
                dateFormat = "MM/YYYY"
                break;
        }
        return moment(value).format(dateFormat);
    }
    else {
        return value;
    }
}

const convertToDMSLat = (lat: any) => {
    const latDegrees = Math.floor(Math.abs(lat));
    const latMinutes = Math.floor((Math.abs(lat) - latDegrees) * 60);
    const latSeconds = ((Math.abs(lat) - latDegrees - latMinutes / 60) * 3600).toFixed(4);
    const latDirection = lat >= 0 ? 'N' : 'S';
    const latDMS = `${latDegrees}° ${latMinutes}' ${latSeconds}" ${latDirection}`;
    return latDMS;
}

const convertToDMSLng = (lng: any) => {
    const lngDegrees = Math.floor(Math.abs(lng));
    const lngMinutes = Math.floor((Math.abs(lng) - lngDegrees) * 60);
    const lngSeconds = ((Math.abs(lng) - lngDegrees - lngMinutes / 60) * 3600).toFixed(4);
    const lngDirection = lng >= 0 ? 'E' : 'W';
    const lngDMS = `${lngDegrees}° ${lngMinutes}' ${lngSeconds}" ${lngDirection}`;
    return lngDMS;
}

const getSelectedDateSessionData = async (userId: any) => {
    try {
        const response = await DistributorService.getSessionData(userId);
        return response;
    } catch (e: any) {
        return "";
    }
};

const getCompName:any = {
    trends: 'myTrends',
    health: 'myHealth',
    location: 'myLocation',
    utilization: 'myUtilization',
    productivity: 'myProductivity',
    tier: 'myTier',
    imc: 'myIMC',
    reporting: 'reporting',
    operations: 'operations'
}

const saveSelectedDateSessionData = async (userId: any, startDate: string, endDate: string, compName: any = '', globalData: any = {}) => {
    if (userId != undefined && userId != null) {
        try {
            const compKey = getCompName?.[compName];
            const compData = JSON.parse(globalData?.[compKey] || '{}');
            const data = { [compKey]: JSON.stringify({ ...compData, startDate, endDate}) }
            await DistributorService.setSessionData(userId, data);
            return data;
        } catch (e: any) {
        }
    }
};

const uploadResources = (t :any) => {
    return {
        upload: {
            cancel: t(RESOURCE.MyK_Label_Cancel),
            clearSelectedFiles: t(RESOURCE.MyK_Label_SC_Up_Clear),
            dropFilesHere: t(RESOURCE.Myk_Label_SC_ShareQuotes_Dropfile),
            headerStatusUploading: t(RESOURCE.MyK_Label_SC_Up_Uploading),
            headerStatusUploaded: t(RESOURCE.MyK_Label_SC_Up_Done),
            remove: t(RESOURCE.MyK_Label_ShoppingCart_Promo_Remove),
            retry: t(RESOURCE.MyK_Label_SC_Up_Retry),
            Total: t(RESOURCE.MyK_Label_SC_Up_Total),
            select: t(RESOURCE.MyK_Label_ShoppingCart_Select_Files),
            selectNoFilesTitle: t(RESOURCE.MyK_Label_ShoppingCart_No_File_Chosen),
            uploadSelectedFiles: t(RESOURCE.MyK_HealthLabel_CPT_Upload),
            total: t(RESOURCE.MyK_Label_SC_Up_Total),
            dropZoneHint: t(RESOURCE.Myk_Label_SC_ShareQuotes_Dropfile)
        }
    }
}

const scrollToTop = () => {
  window.scrollTo({
      top: 0,
  });
};

const formatPhoneNumber = (value: any) => {
    if (value && value != "" && value?.replace(/\D/g, '')?.length >= 10) {
        const number = value?.replace(/\D/g, '')?.slice(0, 10);
        return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
    }
    else
        return '(___) ___-____';
};

const redictBackToOrderTrackingOrHistory = (navigate :any) => {
    if (localStorage.getItem("FromOrderTracking") === 'true') {
        navigate('/ordertracking');
    }
    else {
        navigate('/orderhistory');
    }
}

const getShowShoppingCartFlg = (data: any) => {
    const { headercurrentuser, isMiningDistributor, isWacMixedFleetDistributor } = data;
    const userType = headercurrentuser?.usertype?.name?.toLowerCase();
    let isShow = (userType !== "customer" && userType !== "distributor") ||  // Not a customer or distributor
        headercurrentuser?.isMultiDistributor ||                    // Multi-distributor
        (userType === "distributor" && !isMiningDistributor) ||     // Distributor but NOT mining
        isWacMixedFleetDistributor ||                               // Wac Mixed Fleet Distributor
        (!isMiningDistributor && userType === "customer");          // Customer but NOT mining
    return isShow;
}

const numberToInt = (value: any) => {
    return value && value != "" ? parseInt(value) : value;
}

function downloadBase64Zip(base64Data: string, filename: string = 'download') {
    if (!base64Data) {
        console.warn('No base64 data provided for download.');
        return;
    }
    const binary = atob(base64Data);
    const buffer = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        buffer[i] = binary.charCodeAt(i);
    }

    const blob = new Blob([buffer], { type: 'application/zip' });
    const url = URL.createObjectURL(blob);

    const link = Object.assign(document.createElement('a'), {
        href: url,
        download: `${ filename }.zip`,
        });

     document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

const normalizeDateFilters = (filters: any, columns: any[]): any => {
    if (!Array.isArray(filters)) return filters;
    return filters.map((f: any) => {
        if (f.filters) {
            return {
                ...f,
                filters: normalizeDateFilters(f.filters, columns),
            };
        }
        const col = columns.find((col:any) => col.field === f.field);
        if ((col?.filter === 'date' || col?.filter === 'dateTime') && typeof f.value === 'string') {
            const date = new Date(f.value);
            return isNaN(date.getTime()) ? f : { ...f, value: date };
        }
        return f;
    });
};

export default {
  MenuClickEvent,
  ClearLocalStorage,
  NumberFormat,
  DateFormat,
  YearMonthFormat,
  AddFiltertoEndpoint,
    extractUniqueKeys,
    createSortOptions,
  formatDatesInArray,
  cptArrayConversion,
  transformCPTInput,
  DateFormatbasedONRegion,
  getVisibilityClass,
  isVisibleBasedOnRole,
  handleCustomFilterCriteria,
  shareTo,
  replaceSecondFilter,
  getFiltersByKeyAsString,
  dateIsValid,
  getFiltersoptions,
  getDataOptions,
  showErrorMessage,
  showSuccessMessage,
  showErrorMessageTop,
  showSuccessMessageTop,
  getMachineTitle,
  showWarningMessage,
  formatAmount,
  getDateWithLocalFormat,
  validEmailCheck,
  minMaxValidation,
  requiredValidation,
  lengthValidation,
  getTextWidth,
  customMonthYearFormat,
  validPhoneCheck,
  validPhoneCheckWithPhoneCode,
  showRemainderMessageTop,
  convertToDMSLat,
  convertToDMSLng,
  getSelectedDateSessionData,
  saveSelectedDateSessionData,
  shareOrderConfirmation,
  uploadResources,
  scrollToTop,
  showCreditWarningMessage,
  formatPhoneNumber,
  redictBackToOrderTrackingOrHistory,
  getUnitPrice,
  getShowShoppingCartFlg,
  numberToInt,
    setDefaultUserSessionForShoppingCart,
    downloadBase64Zip,
    normalizeDateFilters
};
